export default {
  startshopping_supplier: {
    subtitle: "FOR SUPPLIERS",

    title1: "Start Selling in",
    title2: "3 Simple Steps",

    desc:
      "Join MAHAL and start receiving orders from verified restaurants with ease.",

    step1_title: "Register as a Supplier",
    step1_desc:
      "Create your supplier account and complete verification to get onboarded quickly.",
    step1_cta: "Create Supplier Account",

    step2_title: "List Your Products",
    step2_desc:
      "Upload products, manage pricing, and make your catalog visible to restaurants.",
    step2_cta: "Manage Products",

    step3_title: "Receive & Fulfil Orders",
    step3_desc:
      "Accept orders from restaurants, deliver on time, and grow your recurring business.",
    step3_cta: "Go to Supplier Dashboard",
  },
};